import { StockRow } from './StockRow';
import { Stock } from "components/Stock/Stock.helper";
import { useTableFilterQuery } from 'components/Forms/TableFilter';
import { useConfigByCountry } from 'routes/Util/Util.hooks';

const TEXT_BY_FIELD_VALUE: Record<string, string> = {
  'trailing-pe': 'PER',
  'forward-pe': '추정 PER',
  'decline-rate': '고점 대비 하락률',
}

export type StockTableProps = {
  country: string;
  sector: string;
  stocks: Stock[];
}

export const StockTable = ({ country, sector, stocks }: StockTableProps) => {
  const { data: filter } = useTableFilterQuery();
  const config = useConfigByCountry(country);

  return (
    <div className="card mb-4">
      <div className="card-header d-flex justify-content-between">
        <span>{config.titleBySector[sector]}</span>
        <span>{TEXT_BY_FIELD_VALUE[filter?.fields]}</span>
      </div>
      <ul className="list-group list-group-flush">
        {stocks.map(stock => <StockRow key={stock.symbol} {...stock} />)}
      </ul>
    </div>
  );
}
